/**
 * Created by dx.yang on 2017/3/20.
 */


export const getImages = 'image/getImages';
export const modifyName = 'image/modifyName';
export const removeImages = 'image/RemoveImages';
export const CheckHasIamRole = 'image/CheckHasIamRole';
export const imagePlatforms = 'image/imagePlatforms';
export const validateImportimg = 'image/validateImportimg';
export const importImages = 'image/importImages';
export const getQutainfos = 'image/getQutainfos';
export const copyImages = 'image/copyImages';
export const switchImageType = 'image/switchImageType';
export const getcopyRegions = 'image/getcopyRegions';
export const getshareAccounts = 'image/getshareRegions';
export const shareImages = 'image/shareImages';
export const getImagesSilence = 'image/getImagesSilence';
export const colsChecked = 'image/colsChecked';
export const DescribeImagesByTagValue = 'image/DescribeImagesByTagValue';
export const warmUpCustomImage = 'image/warmUpCustomImage';
export const cancelWarmUpCustomImage = 'image/cancelWarmUpCustomImage';
export const DescribeLocalImageQuotaAndCount = 'image/DescribeLocalImageQuotaAndCount';
export const QueryWhiteList = 'image/QueryWhiteList';
export const QueryBuckets = 'image/QueryBuckets';
export const ExportImage = 'image/ExportImage';
export const CancelImageExport = 'image/CancelImageExport';

export const DescribeKs3ServiceStatus = 'image/DescribeKs3ServiceStatus';
export const ImageAccelerate = 'image/ImageAccelerate';
export const IsUserSupportImageAccelerate = 'image/IsUserSupportImageAccelerate';
export const ModifyImageAttribute = 'image/ModifyImageAttribute';
